<template>
  <!-- 通话界面 -->
  <div id="call-view" v-show="isCallViewVisible">
    <div class="peer-view main-view" v-show="isPeerViewVisible">
      <video id="video-peer" v-show="isVideoPeerVisible" autoPlay></video>
      <audio id="audio-peer" v-show="isAudioPeerVisible" autoPlay></audio>
      <div class="audio-tip-wrap">
        <!-- <p class="audio-name online-ellipsis">对端姓名</p> -->
        <p class="audio-call">语音通话中</p>
      </div>
    </div>
    <div class="local-view sub-view" v-show="isLocalViewVisible">
      <video id="video-local" v-show="isVideoLocalVisible" autoPlay></video>
      <audio id="audio-local" v-show="isAudioLocalVisible" autoPlay></audio>
      <div class="audio-tip-wrap" v-show="isAudioTipWrapVisible">
        <p class="audio-name online-ellipsis">本机</p>
        <p class="audio-call">语音通话中</p>
      </div>
    </div>
    <div class="op-btns">
      <div class="mute-change-btn">
        <img
          @click="changeMute()"
          :src="muteChangeIcon"
          alt="Mute Change Icon"
        />
        <p class="a-mute">{{ aMuteName }}</p>
      </div>
      <div class="mode-change-btn">
        <img
          :src="modeChangeIcon"
          @click="changeMode()"
          alt="Mode Change Icon"
        />
        <p class="v-mode">{{ modeName }}</p>
      </div>
      <div>
        <img
          @click="dropCall()"
          src="https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661433175110/reject.png"
        />
        <p style="color: #e24940">挂断</p>
      </div>
    </div>
  </div>
</template>

<script>
import { changeMute, changeMode, dropCall } from '@/utils/duerService';
export default {
  data() {
    return {
      isCallViewVisible: false,
      isAudioTipWrapVisible: true,
      isLocalViewVisible: true,
      isPeerViewVisible: false,
      isVideoPeerVisible: false,
      isAudioPeerVisible: false,
      isVideoLocalVisible: false,
      isAudioLocalVisible: false,
      modeChangeIcon: '',
      modeName: '',
      aMuteName: '',
      muteChangeIcon: '',
    };
  },
  methods: {
    // 显示isCallViewVisible弹窗
    callViewShow() {
      this.isCallViewVisible = true;
    },
    // 隐藏isCallViewVisible弹窗
    callViewHide() {
      this.isCallViewVisible = false;
    },
    peerViewShow() {
      this.isPeerViewVisible = true;
    },
    peerViewHide() {
      this.isPeerViewVisible = false;
    },
    audioTipWrapShow() {
      this.isAudioTipWrapVisible = true;
    },
    audioTipWrapHide() {
      this.isAudioTipWrapVisible = false;
    },
    localViewShow() {
      this.isLocalViewVisible = true;
    },
    localViewHide() {
      this.isLocalViewVisible = false;
    },
    videoPeerShow() {
      this.isVideoPeerVisible = true;
    },
    videoPeerHide() {
      this.isVideoPeerVisible = false;
    },
    audioPeerShow() {
      this.isAudioPeerVisible = true;
    },
    audioPeerHide() {
      this.isAudioPeerVisible = false;
    },
    videoLocalShow() {
      this.isVideoLocalVisible = true;
    },
    videoLocalHide() {
      this.isVideoLocalVisible = false;
    },
    audioLocalShow() {
      this.isAudioLocalVisible = true;
    },
    audioLocalHide() {
      this.isAudioLocalVisible = false;
    },
    getMute(aMuteName, muteChangeIcon) {
      this.aMuteName = aMuteName;
      this.muteChangeIcon = muteChangeIcon;
    },
    getCall(modeName, modeChangeIcon) {
      this.modeName = modeName;
      this.modeChangeIcon = modeChangeIcon;
    },
    changeMute() {
      changeMute();
    },
    //挂断通话
    dropCall() {
      dropCall();
    },
  },
};
</script>

<style scoped>
#login-form,
#device-form {
  width: 500px;
  margin: 20px auto 20px;
}
.usr-info {
  text-align: center;
}
.usr-pho {
  margin-top: 35px;
  width: 120px;
  height: 120px;
}
.usr-name {
  margin-top: 10px;
  font-weight: 500;
  font-size: 30px;
  line-height: 42px;
  color: #1a1a1a;
}
.incoming-call-tip {
  font-size: 16px;
  line-height: 22px;
  color: #666666;
}
.op-btns {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.op-btns img {
  width: 80px;
  height: 80px;
  margin: 24px 80px;
  cursor: pointer;
}
.op-txt {
  line-height: 20px;
  text-align: center;
}
#outing-call-view,
#call-view {
  position: fixed;
  width: 50%;
  height: 55%;
  right: 22%;
  top: 18%;
  z-index: 10052;
  background: #080808cf;
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}
#outing-call-view .op-btns {
  margin-top: 50px;
}
.peer-pho {
  width: 104px;
  height: 104px;
  margin-top: 50px;
}
.peer-name {
  font-size: 60px;
  line-height: 86px;
}
.outing-call-tip {
  font-size: 42px;
  line-height: 60px;
  color: rgba(225, 225, 225, 0.5);
}
#call-view .op-btns {
  position: absolute;
  bottom: 50px;
}
.main-view {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  background-image: url('https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661773897681/audioBg.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  color: #fff;
  text-align: center;
}
.main-view video {
  width: 100%;
  object-fit: fill;
}
.main-view .audio-name {
  margin-top: 100px;
  font-size: 62px;
  line-height: 87px;
}
.main-view .audio-call {
  font-size: 36px;
  line-height: 50px;
  color: rgba(225, 225, 225, 0.5);
  margin-top: 17px;
}
.main-view .audio-tip-wrap {
  position: absolute;
  top: 0;
}
.sub-view {
  width: 320px;
  height: 192px;
  position: absolute;
  left: 48px;
  top: 48px;
  background-image: url('https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661773897681/audioBg.png');
  background-repeat: no-repeat;
  background-size: 100%;
  color: #fff;
  z-index: 1;
}
.sub-view video {
  width: 320px;
  height: 192px;
  object-fit: fill;
}
.sub-view .audio-tip-wrap {
  position: absolute;
  bottom: 10px;
  right: 10px;
}
.sub-view .audio-name {
  font-size: 48px;
  line-height: 67px;
  max-width: 300px;
}
.sub-view .audio-call {
  font-size: 24px;
  line-height: 34px;
  text-align: right;
}
#message-alert {
  position: fixed;
  z-index: 1053;
  width: 300px;
  right: 0;
  top: 10px;
  display: none;
}
.desc-title {
  text-align: center;
  margin-bottom: 20px;
}
.modal {
  background: #c0c6d6cf;
  width: 50%;
  height: 40%;
  position: fixed;
  right: 22%;
  top: 20%;
}
</style>
